import { userPageElementApi } from 'api'

const state = {
  elements: [],
  color: 'black',
  tool: 'edit',
  drawMode: 'hide'
}

const getters = {
  elements: state => state.elements,
  elementsByPageNumber: state => pageNumber => {
    return state.elements.filter(d => d.pageNumber === pageNumber)
  },
  color: state => state.color,
  tool: state => state.tool,
  canDraw: state => (state.tool === 'eraser' || state.tool === 'edit' || state.tool === 'marker') && state.drawMode === 'draw',
  drawMode: state => state.drawMode,
  evenPageHasElements: (state, getters) => (getters.evenPage != null && state.elements.filter(e => e.pageNumber === getters.evenPage.pageNumber).length > 0),
  oddPageHasElements: (state, getters) => (getters.oddPage != null && state.elements.filter(e => e.pageNumber === getters.oddPage.pageNumber).length > 0)
}

const actions = {
  setColor ({ commit }, color) {
    commit('setColor', color)
  },
  setTool ({ commit }, tool) {
    commit('setTool', tool)
  },
  getElements ({ commit }) {
    userPageElementApi.getList().then(resp => {
      commit('setElements', resp.data)
    })
  },
  addElement ({ commit }, obj) {
    userPageElementApi.add(obj.pageNumber, obj.type, obj.element).then(resp => {
      commit('addElement', resp.data)
    })
  },
  deleteElement ({ commit }, id) {
    userPageElementApi.delete(id).then(resp => {
      commit('removeElement', id)
    })
  },
  deleteElementsByPageNumber ({ commit }, pageNumber) {
    userPageElementApi.deleteByPageNumber(pageNumber).then(resp => {
      commit('removeElementsByPageNumber', pageNumber)
    })
  },
  setDrawMode ({ commit }, mode) {
    commit('setDrawMode', mode)
  }
}

const mutations = {
  setColor (state, color) {
    state.color = color
  },
  setTool (state, tool) {
    state.tool = tool
  },
  addElement (state, element) {
    state.elements.push(element)
  },
  setElements (state, elements) {
    state.elements = elements
  },
  removeElement (state, id) {
    state.elements.splice(state.elements.findIndex(e => e.id === id), 1)
  },
  removeElementsByPageNumber (state, pageNumber) {
    state.elements = state.elements.filter(e => e.pageNumber !== pageNumber)
  },
  setDrawMode (state, mode) {
    state.drawMode = mode
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
